<script>
	import AtlasHelper from "./AtlasHelper";
	import store from "../../store.js";

	export default {
		url: location.protocol + "//" + location.host + "/map/proxy.jsp?" + "http://apptest:6080/arcgis/rest/services/testDenis/PrintAtlas/GPServer/Tool",
		printAtlasUrl: "/atlas/api/printAtlas",
		// Rezultatai čia -> C:\arcgisserver\directories\arcgisjobs\testdenis\exppdf_gpserver (APPTEST'e)
		getPrintableAtlasParams: function(data, myMap){
			var promise = new Promise(function(resolve, reject){
				var services = [],
					skipCells = [];
				if (myMap) {
					if (myMap.gridLayer) {
						myMap.gridLayer.getSource().getFeatures().forEach(function(feature){
							if (feature.get("ignore")) {
								skipCells.push(feature.get("pos").join("-"));
							}
						});
					}
					var layersPromises = [];
					myMap.getLayers().forEach(function(layer){
						if (layer.service && layer.get("visible")) {
							if (layer.service.type == "edvi-vector" || layer.service.type == "edvi-raster") {
								layersPromises.push(this.getEdviLayerData(layer, myMap, data));
							} else {
								if (layer.service.capabilities && layer.service.capabilities["gisc"]) {
									var capabilities = layer.service.capabilities["gisc"],
										type = capabilities.type;
									if (type) {
										type = type.toLowerCase();
										if (type == "ais") {
											type = "img";
										}
									}
									var visibleLayers;
									if (layer.getSource().getParams) {
										var sourceParams = layer.getSource().getParams();
										if (sourceParams && typeof sourceParams["layers"] !== "undefined") {
											visibleLayers = sourceParams["layers"].replace("show:", "").split(",");
											if (visibleLayers == "-1") {
												visibleLayers = [];
											}
										}
									}
									services.push({
										url: capabilities.serviceUrl,
										opacity: layer.get("opacity"),
										type: type,
										visibleLayers: visibleLayers
									});
								} else {
									console.warn("No GISC capabilities 4 layer", layer);
								}
							}
						}
					}.bind(this));
					Promise.allSettled(layersPromises).then(function(layerPromisesResults){
						var vectorLayersData = [],
							vectorLayersRenderersInfo = {}
						layerPromisesResults.forEach(function(res){
							if (res.status == "fulfilled") {
								if (res.value && res.value.features) {
									if (res.value.layer) {
										var renderer;
										if (res.value.layer.service.capabilities) {
											var capabilities = res.value.layer.service.capabilities.content;
											if (capabilities) {
												renderer = {
													type: "simple",
													symbol: this.getVectorLayerSymbol(capabilities.geometryType)
												};
											}
										}
										vectorLayersRenderersInfo[res.value.layerId] = {
											renderer: renderer,
											opacity: res.value.layer.get("opacity")
										};
										delete res.value.layer;
										vectorLayersData.push(res.value);
									}
								}
							}
						}.bind(this));
						var params = {
							in_services_info: JSON.stringify(services),
							in_print_parameters: JSON.stringify(Object.assign(data, {skipCells: skipCells})),
							in_vector_layers_data: JSON.stringify(vectorLayersData),
							in_vector_layers_renderers_info: JSON.stringify(vectorLayersRenderersInfo),
							atlasID: data.atlasID
						};
						resolve(params);
					}.bind(this));
				} else {
					reject();
				}
			}.bind(this));
			return promise;
		},
		doJob: function(data, myMap, directGP){
			var promise = new Promise(function(resolve, reject){
				this.getPrintableAtlasParams(data, myMap).then(function(params){
					if (directGP) {
						this.submitJob(params).then(function(response){
							var jobId = response.jobId;
							if (jobId) {
								var task = window.setInterval(function(){
									this.checkJob(jobId).then(function(response){
										console.log("JOB STATUS", response.jobStatus); // TEMP...
										if (response.jobStatus == "esriJobSucceeded" || response.jobStatus == "esriJobFailed" || response.jobStatus == "esriJobTimedOut") {
											window.clearInterval(task);
											if (response.jobStatus == "esriJobSucceeded") {
												if (response.results && response.results["out_pdf_file"]) {
													this.getPdfFile(jobId, response.results["out_pdf_file"].paramUrl).then(function(response){
														var url;
														if (response.value && response.value.url) {
															url = response.value.url;
														}
														resolve(url);
													}.bind(this));
												} else {
													reject();
												}
											} else {
												reject();
											}
										}
									}.bind(this));
								}.bind(this), 3000);
							} else {
								reject();
							}
						}.bind(this), function(){
							reject();
						}.bind(this));
					} else {
						// BIG BIG TODO!!! Nustatyti statusą į 0???
						AtlasHelper.getFetchPromise(this.printAtlasUrl, params).then(function(response){
							if (response.success) {
								var task = window.setInterval(function(){
									// Tikriname failo statusą... Jei jis lygus "1", tai viskas ok? Pateikiame vartotojui nuorodą į failą?
									AtlasHelper.getAtlasData(params.atlasID).then(function(data){
										if (data) {
											if (data["status"] > 0) {
												window.clearInterval(task);
												if (data["status"] == 1) {
													var url = AtlasHelper.getPrintedAtlasUrl(params.atlasID);
													resolve(url);
												} else {
													reject();
												}
											}
										} else {
											window.clearInterval(task);
											reject(); // TODO! Tai nebūtinai reiškia, kad nepavyko sugeneruoti PDF failo! Reikia diferencijuoti pranešimus vartotojui...
										}
									}.bind(this), function(){
										window.clearInterval(task);
										reject(); // TODO! Tai nebūtinai reiškia, kad nepavyko sugeneruoti PDF failo! Reikia diferencijuoti pranešimus vartotojui...
									});
								}.bind(this), 3000);
							} else {
								reject();
							}
						}.bind(this), function(){
							reject();
						});
					}
				}.bind(this), function(){
					reject();
				});
			}.bind(this));
			return promise;
		},
		submitJob: function(params){
			var promise = new Promise(function(resolve, reject){
				setTimeout(function(){
					params.f = "json";
					var url = this.url + "/submitJob";
					window.fetch(url, {
						method: "POST",
						body: new URLSearchParams(params).toString(),
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var json;
						if (text) {
							try {
								json = JSON.parse(text);
							} catch(err) {
								// ...
							}
						}
						if (json) {
							resolve(json);
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			}.bind(this));
			return promise;
		},
		checkJob: function(jobId){
			var promise = new Promise(function(resolve, reject){
				setTimeout(function(){
					var url = this.url + "/jobs/" + jobId + "?f=json";
					window.fetch(url, {
						method: "GET",
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var json;
						if (text) {
							try {
								json = JSON.parse(text);
							} catch(err) {
								// ...
							}
						}
						if (json) {
							resolve(json);
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			}.bind(this));
			return promise;
		},
		getPdfFile: function(jobId, paramUrl){
			var promise = new Promise(function(resolve, reject){
				setTimeout(function(){
					var url = this.url + "/jobs/" + jobId + "/" + paramUrl + "?f=json&returnType=data";
					window.fetch(url, {
						method: "GET",
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var json;
						if (text) {
							try {
								json = JSON.parse(text);
							} catch(err) {
								// ...
							}
						}
						if (json) {
							resolve(json);
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			}.bind(this));
			return promise;
		},
		getEdviLayerData: function(layer, myMap, data){
			var promise;
			if (layer.service.type == "edvi-vector") {
				var params = {
					where: "1=1",
					f: "json",
					returnGeometry: true,
					geometryType: "esriGeometryEnvelope",
					geometry: JSON.stringify({
						"xmin": data.xTop,
						"ymin": data.yTop - data.yStep*data.yCount,
						"xmax": data.xTop + data.xStep*data.xCount,
						"ymax": data.yTop,
						"spatialReference": {
							"wkid": 3346
						}
					}),
					spatialRel: "esriSpatialRelIntersects",
					outSR: 3346
				};
				promise = new Promise(function(resolve, reject){
					setTimeout(function(){
						var url = layer.service.url + "/query?" + new URLSearchParams(params).toString();
						window.fetch(url, {
							method: "GET",
							headers: {
								"Content-Type": "application/json"
							}
						}).then(function(response){
							if (response.status == 200) {
								return response.text();
							} else {
								reject();
							}
						}).then(function(text){
							var json;
							if (text) {
								try {
									json = JSON.parse(text);
								} catch(err) {
									// ...
								}
							}
							if (json) {
								json.layerId = layer.service.id; // FIXME! Ar geras ID?..
								json.layer = layer;
								resolve(json);
							} else {
								reject();
							}
						}.bind(this), function(){
							reject();
						});
					}.bind(this), store.state.testDelay);
				}.bind(this));
			} else {
				promise = new Promise(function(resolve){
					resolve();
				});
			}
			return promise;
		},
		getVectorLayerSymbol: function(geometryType){
			var symbol;
			// https://openlayers.org/en/latest/apidoc/module-ol_style_Style-Style.html
			var fillColor = [255, 255, 255, 128],
				outlineColor = [0, 153, 255, 255];
			switch (geometryType) {
				case "esriGeometryPoint":
					symbol = {
						"color": fillColor || [156, 156, 156, 191],
						"size": 6 || 6.999999999999999,
						"angle": 0,
						"xoffset": 0,
						"yoffset": 0,
						"type": "esriSMS",
						"style": "esriSMSCircle",
						"outline": {
							"color": outlineColor || [0, 0, 0, 191],
							"width": 1,
							"type": "esriSLS",
							"style": "esriSLSSolid"
						}
					}
					break;
				case "esriGeometryPolyline":
					symbol = {
						"color": outlineColor || [0, 0, 0, 191],
						"width": 1,
						"type": "esriSLS",
						"style": "esriSLSSolid"
					}
					break;
				case "esriGeometryPolygon":
					symbol = {
						"color": fillColor || [178, 178, 178, 191],
						"outline": {
							"color": outlineColor || [0, 0, 0, 191],
							"width": 1,
							"type": "esriSLS",
							"style": "esriSLSSolid"
						},
						"type": "esriSFS",
						"style": "esriSFSSolid"
					}
					break;
			}
			return symbol;
		}
	}
</script>